
import React from "react";
import { useSearchParams, useNavigate } from "react-router-dom";

const PaymentCancelPage: React.FC = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const orderId = searchParams.get("order_id");

  const handleRetry = () => {
    navigate("/enduser/subscription");
  };

  const handleBackToDashboard = () => {
    navigate("/enduser/dashboard");
  };

  return (
    <div
      dir="rtl"
      className="min-h-screen bg-gradient-to-b from-red-50 to-white flex items-center justify-center p-4"
    >
      <div className="max-w-md w-full bg-white rounded-2xl shadow-xl p-8 text-center">
        {/* אייקון ביטול */}
        <div className="mb-6">
          <div className="w-20 h-20 bg-red-100 rounded-full flex items-center justify-center mx-auto">
            <span className="text-5xl">😕</span>
          </div>
        </div>

        {/* כותרת */}
        <h1 className="text-2xl font-bold text-gray-800 mb-2">
          התשלום בוטל
        </h1>

        <p className="text-gray-600 mb-2">
          לא בוצע חיוב.
        </p>

        <p className="text-gray-500 text-sm mb-8">
          תוכל לנסות שוב בכל עת או לחזור לדשבורד.
        </p>

        {/* כפתורים */}
        <div className="space-y-3">
          <button
            onClick={handleRetry}
            className="w-full bg-blue-600 text-white py-3 px-6 rounded-lg font-medium hover:bg-blue-700 transition-colors shadow-md"
          >
            נסה שוב
          </button>

          <button
            onClick={handleBackToDashboard}
            className="w-full bg-gray-100 text-gray-700 py-3 px-6 rounded-lg font-medium hover:bg-gray-200 transition-colors"
          >
            חזרה לדשבורד
          </button>
        </div>

        {/* מספר הזמנה (אופציונלי) */}
        {orderId && (
          <p className="text-xs text-gray-400 mt-6">מספר הזמנה: {orderId}</p>
        )}
      </div>
    </div>
  );
};

export default PaymentCancelPage;